import { BaseClient } from '../BaseClient';
import { Business, BusinessList } from '../compiled-protos/business';
import { BusinessServiceClient } from '../compiled-protos/business.client';

class BusinessClient extends BaseClient {
  self: BusinessServiceClient;

  constructor(host: string, userID?: number) {
    super(host, userID);
    this.self = new BusinessServiceClient(this.transport);
  }

  public async Create(req: Business) {
    let res = Business.create();
    try {
      res = await this.self.create(req, this.getMetaData()).response;
    } catch (err) {
      console.log(err);
      return;
    }
    return res;
  }

  public async Get(req: Business) {
    let res = Business.create();
    try {
      res = await this.self.get(req, this.getMetaData()).response;
    } catch (err) {
      console.log(err);
      return;
    }
    return res;
  }

  public async BatchGet(req: Business) {
    let res = BusinessList.create();
    try {
      res = await this.self.batchGet(req, this.getMetaData()).response;
    } catch (err) {
      console.log(err);
      return;
    }
    return res;
  }

  public async Update(req: Business) {
    let res = Business.create();
    try {
      res = await this.self.update(req, this.getMetaData()).response;
    } catch (err) {
      console.log(err);
      return;
    }
    return res;
  }

  public async Delete(req: Business) {
    try {
      await this.self.delete(req, this.getMetaData()).response;
    } catch (err) {
      console.log(err);
      return false;
    }
    return true;
  }
}

export { Business, BusinessList, BusinessClient };
